import React from 'react';

const ManagerDistribution = ({ country, clientData }) => {
  if (!country) return null;
  
  // Simple filtering without useMemo to avoid potential issues
  const countryClients = clientData.filter(client => client.country === country.country);
  
  // Manager calculations
  const managerGroupCounts = {};
  countryClients.forEach(client => {
    const manager = client.conference_manager;
    if (manager) {
      managerGroupCounts[manager] = (managerGroupCounts[manager] || 0) + 1;
    }
  });
  
  const sortedManagers = Object.keys(managerGroupCounts).sort((a, b) => 
    managerGroupCounts[b] - managerGroupCounts[a]
  );

  return (
    <div className="managers-section">
      <h3>Manager Distribution</h3>
      <div className="manager-bars">
        {sortedManagers.map((manager, index) => {
          const count = managerGroupCounts[manager];
          const percentage = (count / country.total) * 100;
          const color = country.dominantManager === manager ? '#0074D9' : '#7FDBFF'; // Use blue colors for consistency
          
          return (
            <div key={index} className="manager-bar-item">
              <div className="manager-info">
                <span className="manager-name">{manager}</span>
                <span className="manager-count">{count} groups</span>
              </div>
              <div className="bar-container">
                <div 
                  className="bar" 
                  style={{ 
                    width: `${percentage}%`,
                    backgroundColor: color
                  }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ManagerDistribution;
